/**
 * @generated SignedSource<<83bfcd653ad9511e7018e371337b4cfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactLastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFirstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactPhone",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address1",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address2",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxCharge",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "floatLimit",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBudgets",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payFromBalance",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupActive",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupAmount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupThreshhold",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxMonthlyBudget",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personaInquiryId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personaStatus",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verificationComplete",
  "storageKey": null
},
v26 = {
  "kind": "Literal",
  "name": "condition",
  "value": {
    "psStatus": 0
  }
},
v27 = [
  (v26/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "PS_ORDER_ASC"
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccBrand",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccLast4",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccExpy",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achAccountNum",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paypalEmail",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declineCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDeclineReason",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDeclineChargeAmount",
  "storageKey": null
},
v43 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "bcStatus": 0
    }
  }
],
v44 = [
  (v28/*: any*/)
],
v45 = {
  "alias": "activeCards",
  "args": (v43/*: any*/),
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "bindCardTsByProvisioningAccountId",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": "bindCardTsByProvisioningAccountId(condition:{\"bcStatus\":0})"
},
v46 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "bcStatus": -1
    }
  }
],
v47 = {
  "alias": "pendingCards",
  "args": (v46/*: any*/),
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "bindCardTsByProvisioningAccountId",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": "bindCardTsByProvisioningAccountId(condition:{\"bcStatus\":-1})"
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v52 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "appStatus": 0
    }
  }
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": [
    (v26/*: any*/)
  ],
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0})"
},
v55 = {
  "alias": "activeCards",
  "args": (v43/*: any*/),
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "bindCardTsByUsingAccountId",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": "bindCardTsByUsingAccountId(condition:{\"bcStatus\":0})"
},
v56 = {
  "alias": "pendingCards",
  "args": (v46/*: any*/),
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "bindCardTsByUsingAccountId",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": "bindCardTsByUsingAccountId(condition:{\"bcStatus\":-1})"
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerDashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": (v27/*: any*/),
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0},orderBy:\"PS_ORDER_ASC\")"
          },
          (v45/*: any*/),
          (v47/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppTsConnection",
            "kind": "LinkedField",
            "name": "appTsByAccountId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": (v52/*: any*/),
                    "concreteType": "CustomerAppTsConnection",
                    "kind": "LinkedField",
                    "name": "customerAppTsByAppId",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomerAppT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountT",
                            "kind": "LinkedField",
                            "name": "accountTByCustomerAccountId",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "customerAppTsByAppId(condition:{\"appStatus\":0})"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTsConnection",
            "kind": "LinkedField",
            "name": "accountTsByParentId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v53/*: any*/),
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerDashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": (v27/*: any*/),
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0},orderBy:\"PS_ORDER_ASC\")"
          },
          (v45/*: any*/),
          (v47/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppTsConnection",
            "kind": "LinkedField",
            "name": "appTsByAccountId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": (v52/*: any*/),
                    "concreteType": "CustomerAppTsConnection",
                    "kind": "LinkedField",
                    "name": "customerAppTsByAppId",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomerAppT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountT",
                            "kind": "LinkedField",
                            "name": "accountTByCustomerAccountId",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v2/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "customerAppTsByAppId(condition:{\"appStatus\":0})"
                  },
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTsConnection",
            "kind": "LinkedField",
            "name": "accountTsByParentId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v53/*: any*/),
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "101dc6c022e2dd955c71632c4680f897",
    "id": null,
    "metadata": {},
    "name": "CustomerDashboardQuery",
    "operationKind": "query",
    "text": "query CustomerDashboardQuery(\n  $accountId: UUID!\n) {\n  accountTByAccountId(accountId: $accountId) {\n    accountName\n    accountType\n    description\n    contactLastName\n    contactFirstName\n    contactPhone\n    address1\n    address2\n    city\n    state\n    country\n    postalCode\n    maxCharge\n    floatLimit\n    accountStatus\n    useBudgets\n    payFromBalance\n    autoTopupActive\n    autoTopupAmount\n    autoTopupThreshhold\n    maxMonthlyBudget\n    personaInquiryId\n    personaStatus\n    verificationComplete\n    paymentSourceTsByAccountId(condition: {psStatus: 0}, orderBy: PS_ORDER_ASC) {\n      totalCount\n      nodes {\n        psId\n        psType\n        psStatus\n        ccBrand\n        ccLast4\n        ccExpy\n        fiName\n        achAccountNum\n        firstName\n        lastName\n        paypalEmail\n        declineCount\n        lastDeclineReason\n        lastDeclineChargeAmount\n        nodeId\n      }\n    }\n    activeCards: bindCardTsByProvisioningAccountId(condition: {bcStatus: 0}) {\n      totalCount\n    }\n    pendingCards: bindCardTsByProvisioningAccountId(condition: {bcStatus: -1}) {\n      totalCount\n    }\n    appTsByAccountId {\n      totalCount\n      nodes {\n        appId\n        appName\n        appSku\n        appLogo\n        customerAppTsByAppId(condition: {appStatus: 0}) {\n          totalCount\n          nodes {\n            accountTByCustomerAccountId {\n              accountId\n              accountName\n              nodeId\n            }\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n    accountTsByParentId {\n      totalCount\n      nodes {\n        accountId\n        accountName\n        contactFirstName\n        contactLastName\n        paymentSourceTsByAccountId(condition: {psStatus: 0}) {\n          totalCount\n        }\n        activeCards: bindCardTsByUsingAccountId(condition: {bcStatus: 0}) {\n          totalCount\n        }\n        pendingCards: bindCardTsByUsingAccountId(condition: {bcStatus: -1}) {\n          totalCount\n        }\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "942b02d3558dbaf05e3ce4f4abe7d1d5";

module.exports = node;
